import React, { useState } from 'react';
import { DateRangePicker } from 'react-dates';
import './DatePicker.scss'

const CustomDateRangePicker = ({
    initialStartDate = null,
    initialEndDate = null,
    onDatesChange,
    displayFormat = "DD/MM/YYYY",
    numberOfMonths = 1,
    showClearDates = true,
    isOutsideRange = () => false,
    ...props
}) => {
    const [startDate, setStartDate] = useState(initialStartDate);
    const [endDate, setEndDate] = useState(initialEndDate);
    const [focusedInput, setFocusedInput] = useState(null);

    const handleDatesChange = ({ startDate, endDate }) => {
        setStartDate(startDate);
        setEndDate(endDate);
        if (onDatesChange) {
            onDatesChange({ startDate, endDate });
        }
    };

    return (
        <DateRangePicker
            startDate={startDate}
            startDateId="start-date-id"
            endDate={endDate}
            endDateId="end-date-id"
            onDatesChange={handleDatesChange}
            focusedInput={focusedInput}
            onFocusChange={setFocusedInput}
            displayFormat={displayFormat}
            isOutsideRange={isOutsideRange}
            numberOfMonths={numberOfMonths}
            showClearDates={showClearDates}
            {...props}
        />
    );
};

export default CustomDateRangePicker;